//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'OttawaAnkleRule',
  data() {
    return {
      form:{
        painmalleolarzone:'0',
        painmidfootzone:'0',
        inabilitybearweight:'0',
        posterior:'0',
        base:'0',
        navicular:'0',
      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        "Bone tenderness at the navicular bone": "足舟骨骨压痛",
        "Ankle imaging required": "需要踝部摄片",
        "Bone tenderness at posterior tip or edge of either malleolus within distal 6 cm": "踝骨后尖端、踝骨及其远端 6 cm 内某一侧边压痛",
        "Foot imaging required": "需要足部摄片",
        "No imaging": "无需影像",
        "Inability to bear weight both immediately and in ED": "受伤即刻和急诊就诊时均无法负重",
        "Pain in malleolar zone": "踝部疼痛",
        "Ankle and Foot imaging required": "需要足踝摄片",
        "Pain in midfoot zone": "足中部疼痛",
        "Bone tenderness at base of 5th metatarsal": "第 5 跖骨基底骨压痛"
      },
      paininmalleolarorfoot:0,
      footimagingrequired:0,
      ankleimagingrequired:0
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
            form[key]=0
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      // paininmalleolarorfoot
        self.paininmalleolarorfoot = form.painmalleolarzone ? 1 : form.painmidfootzone

        // base ? 1 : (navicular ? 1 : (painmidfootzone ? inabilitybearweight : 0))
        self.footimagingrequired = form.base ? 1 : (form.navicular ? 1 : (form.painmidfootzone ? form.inabilitybearweight : 0))

        // posterior ? 2 : (painmalleolarzone ? (inabilitybearweight ? 2 : 0) : 0)
        self.ankleimagingrequired = form.posterior ? 2 : (form.painmalleolarzone ? (form.inabilitybearweight ? 2 : 0) : 0)

      // ankleimagingrequired + footimagingrequired
      let result =  self.ankleimagingrequired +  self.footimagingrequired
      self.hasScore = true
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/OttawaAnkleRule.vue